import { useEffect, useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { FaDeleteLeft } from "react-icons/fa6";

const PinKeypad = ({ length = 4, value, onChange, error }) => {
    const [showPin, setShowPin] = useState(false);

    const handleKeyPress = (digit) => {
        if (value.length >= length) return;
        onChange(value + digit);
    };

    const handleBackspace = () => onChange(value.slice(0, -1));

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (/^[0-9]$/.test(e.key)) {
                handleKeyPress(e.key);
            } else if (e.key === "Backspace") {
                e.preventDefault();
                handleBackspace();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, length, onChange]);

    return (
        <div className="flex flex-col items-center w-full">
            <div className="flex gap-2 justify-center mb-2">
                {[...Array(length)].map((_, index) => (
                    <div
                        key={index}
                        className={`w-11 h-11 rounded-lg flex items-center justify-center border-2 transition-all ${value.length > index
                            ? "border-[#4cb6f9] bg-[#BDE6FF]/20 dark:bg-[#333333]"
                            : "border-[#BDE6FF] dark:border-gray-800/50 bg-white dark:bg-[#1E1D21]"
                            }`}
                    >
                        <span className="text-[18px] font-bold text-black dark:text-white">
                            {value[index] ? (showPin ? value[index] : "•") : ""}
                        </span>
                    </div>
                ))}
            </div>

            <button
                type="button"
                onClick={() => setShowPin((prev) => !prev)}
                className="flex items-center gap-1 text-[12px] text-gray-600 dark:text-gray-400 mb-1"
            >
                {showPin ? <FiEye size={14} /> : <FiEyeOff size={14} />}
                {showPin ? "Hide PIN" : "Show PIN"}
            </button>

            {error && <p className="text-red-500 text-[12px] font-medium mt-1">{error}</p>}

            <div className="w-full max-w-[260px] mt-6">
                <div className="flex flex-col gap-3">
                    {[[1, 2, 3], [4, 5, 6], [7, 8, 9]].map((row) => (
                        <div key={row[0]} className="flex justify-center gap-4">
                            {row.map((num) => (
                                <button
                                    key={num}
                                    type="button"
                                    onClick={() => handleKeyPress(String(num))}
                                    className="w-14 h-14 rounded-xl bg-white dark:bg-[#2a292c] shadow-md active:scale-95 transition-all flex items-center justify-center text-[18px] font-bold text-black dark:text-white border border-gray-200 dark:border-gray-700"
                                >
                                    {num}
                                </button>
                            ))}
                        </div>
                    ))}
                    <div className="flex justify-center gap-4">
                        <div className="w-14 h-14" />
                        <button
                            type="button"
                            onClick={() => handleKeyPress("0")}
                            className="w-14 h-14 rounded-xl bg-white dark:bg-[#2a292c] shadow-md active:scale-95 transition-all flex items-center justify-center text-[18px] font-bold text-black dark:text-white border border-gray-200 dark:border-gray-700"
                        >
                            0
                        </button>
                        <button
                            type="button"
                            onClick={handleBackspace}
                            className="w-14 h-14 rounded-xl bg-[#BDE6FF] shadow-md active:scale-95 transition-all flex items-center justify-center"
                        >
                            <FaDeleteLeft className="text-[18px] text-black" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PinKeypad;
